// src/components/auth/AuthInitializer.jsx
import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";

const AuthInitializer = () => {
  const { validateToken, tokenValidated, isLoading, markTokenValidated } =
    useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    if (tokenValidated) return;

    ran.current = true;

    const token = localStorage.getItem("token");
    if (token) validateToken();
    else markTokenValidated();
  }, [validateToken, tokenValidated, markTokenValidated]);

  if (!tokenValidated && isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900" />
      </div>
    );
  }
  return null;
};

export default AuthInitializer;
